import { AUTORI, SLUG, TEMI } from 'utils/endpoint'
import { useState } from 'react'
import { api } from 'utils'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import Error from 'next/error'
import MetaSeo from 'components/atomic/MetaSeo'
import BoxAutori from 'components/BoxAutori'
import { useRouter } from 'next/router'
import BoxRisorse from 'components/BoxRisorse'
import BoxTemaDelMomento from 'components/BoxTemaDelMomento'
import BoxTagCloud from 'components/BoxTagCloud'
import Head from 'next/head'
import React from 'react'
import { Actions } from 'react-components/organisms'

const TemaDetail = React.memo(({ tema, page, statusCode, autori, risorseSponsorizzate }) => {
  if (!tema) return <Error statusCode={statusCode} />

  const router = useRouter()

  const background = tema.main_image
    ? { backgroundImage: `url(${tema.main_image})` }
    : { backgroundColor: `black` }

  const urlRisorse = `${router.asPath.split('?')[0]}/risorse?filtri_id=${tema.valore_attributo}`

  const urlAutori = `/autori?filtri_id=${tema.valore_attributo}`

  return (
    <>
      {tema ? (
        <>
          <MetaSeo seo={page.seo} />
          {tema.main_image ? (
            <Head>
              <link rel="preload" href={tema.main_image} as="image" />
            </Head>
          ) : null}
          <main className="hub-page hub-page--tema">
            <div
              className="w-container-fluid u-before-section u-background-image"
              style={background}
            >
              <div className="w-container">
                <Breadcrumbs breadcrumbs={page.breadcrumbs} />
              </div>
              <section className="hub-page__header">
                <div className="w-container">
                  <h1 className="hub-page__header__title">{tema.titolo}</h1>
                </div>
              </section>
            </div>
            <section className="hub-page__content u-bg-white">
              <BoxTemaDelMomento tema={tema} inTema items={risorseSponsorizzate} />
              {tema.tag_cloud.length ? (
                <BoxTagCloud
                  title={`Esplora le materie ${tema.titolo}`}
                  description={`Qui trovi gli argomenti più cercati dalla community di Giunti Scuola. Trova quello che fa per te e prepara la tua prossima lezione. ${tema.titolo}`}
                  tags={tema.tag_cloud}
                  baseHref={urlRisorse}
                  variant="beige"
                />
              ) : null}
              {autori.length ? <BoxAutori autori={autori} href={urlAutori} /> : null}
              <BoxRisorse href={urlRisorse} />
              <div className="w-container">
                <Actions item={tema} labelGTM="tema" follow share />
              </div>
            </section>
          </main>
        </>
      ) : null}
    </>
  )
})

export async function getStaticPaths() {
  const response = await api.get(TEMI)
  const temi = response.data

  const paths = temi
    .map((t) => ({
      params: { slug: t.slug },
    }))
    .slice(0, 1)

  return {
    paths,
    fallback: 'blocking',
  }
}

export const getStaticProps = async ({ params: { slug } }) => {
  try {
    const response = await api.get(`${TEMI}${SLUG}${slug}/`)
    const tema = response.data

    const page = tema.pagina

    const toolbarProps = { toolbarItem: tema, toolbarPage: page }

    const params = {
      attributi__valore_attributo_id: tema.valore_attributo,
      limit: 4,
      relevance: 1,
    }
    const autoriResponse = await api.get(AUTORI, { params })
    const autori = autoriResponse.data || []

    let risorseSponsorizzate = null
    if (tema.id) {
      const risorseSponsorizzateResponse = await api.get(
        `${TEMI}${tema.id}/risorse_sponsorizzate/`,
        {
          params: { limit: 3 },
        }
      )
      risorseSponsorizzate = risorseSponsorizzateResponse.data.risorse
    }

    return {
      props: { tema, page, key: tema.id, ...toolbarProps, autori, risorseSponsorizzate },
      revalidate: 60 * 2,
    }
  } catch (error) {
    console.log(error)
    return {
      notFound: true,
    }
  }
}

export default TemaDetail
